import React, { useContext } from 'react'

const HostContext = React.createContext()

export function HostProvider({ host, children }) {
  return <HostContext.Provider value={host}>{children}</HostContext.Provider>
}

export function useHost() {
  return useContext(HostContext)
}
